module.exports = __webpack_public_path__ + "img/ihkpfaz.4b867442.svg";